import actionCreatorFactory from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';



import { call, put, takeEvery } from 'redux-saga/effects';
import * as TmSetsubiApi from '../Api/TmSetsubiApi';
import * as SearchRoomsApi from '../Api/SearchRoomsApi';

export interface RoomsState {
    setsubi_master: any;
    rooms: any;
    room_details: any;
    response_rooms: any;
}

const initialState: RoomsState = {

    setsubi_master: [],
    rooms: [],
    room_details: [],
    response_rooms: [],
    // rentAgents: [],
    // rentMReasons: [],



}



///action 
const actionCreator = actionCreatorFactory();

export const get_setsubi_master = actionCreator('GET_SETSUBI_MASTER');
export const get_setsubi_master_success = actionCreator("GET_SETSUBI_MASTER_SUCCESS");
export const get_setsubi_master_failure = actionCreator("GET_SETSUBI_MASTER_FAILURE");



export const get_rooms = actionCreator('GET_ROOMS');
export const get_rooms_success = actionCreator("GET_ROOMS_SUCCESS");
export const get_rooms_failure = actionCreator("GET_ROOMS_FAILURE");


export const get_response_rooms = actionCreator<any>('GET_RESPONSE_ROOMS');
export const get_response_rooms_success = actionCreator<any>("GET_RESPONSE_ROOMS_SUCCESS");


export const get_room_details = actionCreator('GET_ROOM_DETAILS');
export const get_room_details_success = actionCreator<any>("GET_ROOM_DETAILS_SUCCESS");
export const get_room_details_failure = actionCreator("GET_ROOM_DETAILS_FAILURE");

//  const getUsers = actionCreator('USERS_REQUEST');
// export const getUsersSuccess = actionCreator("USERS_SUCCESS");
// export const getUsersFailure = actionCreator("USERS_FAILURE");

// export const getRentAgents = actionCreator('RENT_AGENTS_REQUEST');
// export const getRentAgentsSuccess = actionCreator("RENT_AGENTS_SUCCESS");
// export const getRentAgentsFailure = actionCreator("RENT_AGENTS_FAILURE");


// export const getRentMReasons = actionCreator('RENT_M_REASONS_REQUEST');
// export const getRentMReasonsSuccess = actionCreator("RENT_M_REASONS_SUCCESS");
// export const getRentMReasonsFailure = actionCreator("RENT_M_REASONS_FAILURE");


export const roomsReducer = reducerWithInitialState(initialState)
    .case(get_setsubi_master_success, (state, payload) => ({ ...state, setsubi_master: payload }))
    .case(get_room_details_success, (state, payload) => ({ ...state, room_details: payload }))

    .case(get_response_rooms_success, (state, payload) => ({ ...state, response_rooms: payload }))


    .case(get_rooms_success, (state, payload) => ({ ...state, rooms: payload }));
// .case(getUsersSuccess, (state, payload) => ({ ...state, users: payload }))
// .case(getUsersFailure, (state, payload) => ({ ...state, users: payload }))
// .case(getRentAgentsSuccess, (state, payload) => ({ ...state, rentAgents: payload }))
// .case(getRentAgentsFailure, (state, payload) => ({ ...state, rentAgents: payload }))
// .case(getRentMReasonsSuccess, (state, payload) => ({ ...state, rentMReasons: payload }))
// .case(getRentMReasonsFailure, (state, payload) => ({ ...state, rentMReasons: payload }));







// 「LOGIN_REQUEST」アクションが呼ばれるのを待つ呼ばれたhandleRequestを実行
export const roomsSaga = [takeEvery('GET_SETSUBI_MASTER', handleRequestSetsubiMaster),
takeEvery('GET_ROOMS', handleGetRoomsRequest),
takeEvery('GET_ROOM_DETAILS', handleGetRoomDetailsRequest),
takeEvery('GET_RESPONSE_ROOMS', handle_get_response_rooms),


    // takeEvery('RENT_AGENTS_REQUEST', handleRentAgentsRequest),
    // takeEvery('RENT_M_REASONS_REQUEST', handleRentMReasonsRequest),
];
// export default masterSaga;



function* handleRequestSetsubiMaster(action: any) {

    const { payload, error } = yield call(TmSetsubiApi.get_setsubi, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        console.log(payload)

        // const setsubis = payload.map((item:any, i:number) => ({
        //     value: item.setsubiNo,
        //     label: item.setsubiName,
        //   }))

        // 成功時アクション呼び出し


        //yield put(get_setsubi_master_success(setsubis));
        yield put(get_setsubi_master_success(payload));

    } else {
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}


function* handleGetRoomsRequest(action: any) {

    const { payload, error } = yield call(SearchRoomsApi.list, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        console.log(payload)

        yield put(get_rooms_success(payload));

    } else {
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}


function* handleGetRoomDetailsRequest(action: any) {
    yield put(get_room_details_success([]));
    const { payload, error } = yield call(SearchRoomsApi.detail, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {

        console.log(payload)

        yield put(get_room_details_success(payload));

    } else {
        alert("エラー")
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}

function* handle_get_response_rooms(action: any) {

    const { payload, error } = yield call(SearchRoomsApi.response_list, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        console.log(payload)

        yield put(get_response_rooms_success(payload));

    } else {
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}

